import { Paper, Typography } from '@mui/material';
import PropTypes from 'prop-types';
// material

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  searchQuery: PropTypes.string
};

export default function SearchNotFound({ searchQuery = '', ...other }) {
  return (
    <Paper {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        ooops!
      </Typography>
      <Typography variant="body2" align="center">
        Nenhum resultado foi encontrado &nbsp;
        <strong>&quot;{searchQuery}&quot;</strong>. Tente usar outras palavras
      </Typography>
    </Paper>
  );
}
